import { Stack } from "@mui/material";

export default function AuthLinkExpired() {
  return (
    <Stack
      alignItems="flex-start"
      sx={{
        mt: "100px",
        pl: "40px",
      }}
    >
      <h1>Magic Link Expired</h1>
    </Stack>
  );
}
